import MapFooter from '../../../public/svg_images/map-footer.svg';

function MapFooterSvg() {
  return (
    <div className='bg-[#04BBDC] w-[29px] h-[26px] flex items-center justify-center rounded-md'>
    <MapFooter
      width={11}
      height={13}
      role="img" aria-label="Sales office location" 
    />
    </div>
  );
}

export default MapFooterSvg;